import service from '../utils/request'
// 查询列表
export const query = params => {return service.post(`/api/base_charge_rule/query`, params)};
// 创建
export const create = params => {return service.post(`/api/base_charge_rule/create`, params)};
// 修改
export const edit = params => {return service.put(`/api/base_charge_rule/edit`, params)};
// 删除
export const deleted = params => {return service.delete(`/api/base_charge_rule/delete`, {params})};
